import { Api } from "./api.service";

function getEvents(params) {
  return Api.get("/event-log/events", { params });
}

function getEventsByUserId(userId, params) {
  return Api.get(`/event-log/events/${userId}`, { params });
}

export { getEvents, getEventsByUserId };
